import type { ChatSessionModel } from "@/api/models"

import { BookOpen, Folder, Globe, MessageSquareText, Telescope, Workflow } from "@/components/icons"

export function getSessionIcon(session: ChatSessionModel) {
  if (session?.projectId) {
    return <Folder className="size-4 shrink-0" />
  }

  const rawType = (session?.lastFunctionUsed || session?.iconType || "chat") as string
  const normalized = rawType.toString().trim().toLowerCase().replaceAll("-", "_")

  const iconMap: Record<string, React.ReactNode> = {
    agent: <Telescope className="size-4 shrink-0" />,
    flow: <Workflow className="size-4 shrink-0" />,
    prompt_template: <BookOpen className="size-4 shrink-0" />,
    prompttemplate: <BookOpen className="size-4 shrink-0" />,
    web_search: <Globe className="size-4 shrink-0" />,
    websearch: <Globe className="size-4 shrink-0" />,
  }

  return iconMap[normalized] ?? <MessageSquareText className="size-4 shrink-0" />
}
